import { IconProps } from './IconProps';

export const LightingBrightIcon = ({ className, width = 31, height = 32 }: IconProps) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 31 32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="#2396FD" fillRule="nonzero">
      <path d="M14.151.5h2.461v6.153h-2.461zM14.151 25.111h2.461v6.152h-2.461zM0 14.652h6.152v2.462H0zM24.611 14.652h6.152v2.462h-6.152zM3.635 5.873l1.74-1.74 4.351 4.352-1.74 1.74zM21.036 23.277l1.74-1.74 4.35 4.35-1.74 1.74zM5.375 27.628l-1.74-1.74 4.351-4.35 1.74 1.74zM21.037 8.487l1.742 1.74 4.35-4.35-1.739-1.742zM8.358 2.142l2.275-.943 2.355 5.684-2.275.942zM20.052 23.937l-2.274.94 2.356 5.687 2.273-.942zM.701 20.63l.943 2.277 5.684-2.356-.942-2.273zM24.38 13.489l-.942-2.274 5.685-2.354.941 2.274zM.7 11.13l.941-2.272 5.684 2.354-.942 2.273zM24.38 18.275l-.942 2.274 5.684 2.356.94-2.275zM8.36 29.622l2.275.942 2.352-5.684-2.273-.945zM17.778 6.886l2.274.94 2.355-5.684-2.276-.943z" />
    </g>
  </svg>
);
